import {EventEmitter, Injectable, Output} from '@angular/core';
import {ListenerService} from './listener.service';
import {DataaccessListenerService} from './dataaccess-listener.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';
import {WebsocketService} from './websocket.service';
import {ConfService} from './conf.service';
import {Router} from '@angular/router';
import {KongService} from './kong.service';
import {environment} from '../environments/environment';
import {EntityVersionChangeConfirmationComponent} from './edit-entity/edit-entity.component';
import {BusinesslogicListenerService} from './businesslogic-listener.service';
import {DialogComponent} from './shared/dialog/dialog.component';
import {NgxXml2jsonService} from 'ngx-xml2json';
import {MatDialog} from '@angular/material';
import { Subject } from 'rxjs/Subject';
import {AppComponent} from './app.component';
import {AuditListenerService} from './audit-listener.service';

@Injectable({
    providedIn: 'root'
})
export class ApiCreatorsService {

    currentMessage: any;
    partner = localStorage.getItem('partner');
    partnerKey = localStorage.getItem('partnerKey');
    account_id = localStorage.getItem('account');
    connection: boolean;
    logVisible: boolean;
    action: string;
    isAPIAlreadyPresent: boolean;
    isAPIAlreadyPresentCheckCompleted = false;
    previouslyCheckedName: any;
    previouslyCheckedVersion: any;
    isValidTableName = false;
    private isUseExistingTable: boolean;
    private isCheckForExistingTableCompleted: boolean;
    private isAPIDefinitionImportedFromExistingTable: boolean;
    private previousTableName: any;
    private previousSelectedDatatypeFilter: any;
    private selectedDatatypeFilter: any;

    private eventCallback: Subject<any> = new Subject<any>();

    eventCallback$ = this.eventCallback.asObservable();


    constructor(
        public platform: LeftpanelComponent,
        public dataAccessListenerInstance: DataaccessListenerService,
        public auditListenerService: AuditListenerService,
        private leftPanelDataListener: ListenerService,
        public dialog: MatDialog,
        private kongService: KongService,
        private router: Router,
        public confPost: ConfService,
        private websocketService: WebsocketService,
        private appComp: AppComponent,
        private businessLogicListenerInstance: BusinesslogicListenerService,
        private ngxXml2jsonService: NgxXml2jsonService) {
    }

    listenAPICreation(timestamp, apiName, apiVersion) {
        this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, 'deploy').subscribe(data => {
            if (data) {
                this.currentMessage = JSON.parse(data['body']);
            }
        });
    }

    checkForExistingExecutor(entityName, entityVersion, editFlag, timeStamp, action) {
        return new Promise((resolve, reject) => {
            if (!editFlag) {
                this.platform.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                    info: 'Checking for API existence',
                    type: 'initial',
                    icon: 'fa fa-check'
                }, timeStamp, action);
                Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(entityName, entityVersion)).then(response => {
                    this.platform.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Checking for API existence',
                        type: 'success',
                        icon: 'fa fa-check'
                    }, timeStamp, action);
                    resolve(true);
                }, error => {

                    this.platform.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Checking for API existence',
                        type: 'fatal',
                        description: 'An API with the provided name and version already exists.',
                        icon: 'fa fa-check'
                    }, timeStamp, action);
                    resolve(false);
                    // this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                });
            } else {
                resolve(true);
            }
        });
    }

    // checkForExistingTableAndAttributes(entity, params) {
    //     return new Promise((resolve, reject) => {
    //         const deleteDialog = this.dialog.open(LoaderWithProgressComponent, {
    //             maxWidth: '95vw',
    //             maxHeight: '60vh',
    //         });
    //         this.confPost.checkIfTableExists(this.partner, entity.tableName, entity.selectDatabase, params.selectedDatatypeFilter).subscribe(response => {
    //             if (response && response !== undefined && response !== null) {
    //                 deleteDialog.close();
    //                 const dialogRef = this.dialog.open(UseExistingTableConfirmationComponent, {
    //                     width: 'auto',
    //                     height: 'auto',
    //                     data: {
    //                         message: 'Checking for table existence...'
    //                     }
    //                 });
    //                 dialogRef.afterClosed().subscribe(result => {
    //                     if (result) {
    //                         if (result === 'yes') {
    //                             const deleteDialog1 = this.dialog.open(LoaderWithProgressComponent, {
    //                                 maxWidth: '95vw',
    //                                 maxHeight: '60vh',
    //                                 data: {
    //                                     message: 'Retrieving existing table attributes...'
    //                                 }
    //                             });
    //                             this.confPost.getTableAttributes(this.partner, entity.tableName, entity.selectDatabase, params.selectedDatatypeFilter).subscribe(response1 => {
    //                                 if (response1) {
    //                                     this.isUseExistingTable = true;
    //                                     this.isCheckForExistingTableCompleted = false;
    //                                     deleteDialog1.close();
    //                                     entity.apiByDefinition = response1;
    //                                     this.isAPIDefinitionImportedFromExistingTable = true;
    //                                     this.previousTableName = entity.tableName;
    //                                     this.previousSelectedDatatypeFilter = this.selectedDatatypeFilter;
    //                                     resolve('success');
    //                                 } else {
    //                                     this.platform.openSnackBar('Error while retrieving the existing table attributes. Please try again after sometime.', 'Error', {
    //                                         duration: 10000,
    //                                         verticalPosition: 'top',
    //                                         horizontalPosition: 'center'
    //                                     });
    //                                     this.isCheckForExistingTableCompleted = false;
    //                                     deleteDialog1.close();
    //                                     this.router.navigateByUrl('/controlplane');
    //                                 }
    //                             }, error => {
    //                                 this.isCheckForExistingTableCompleted = false;
    //                                 deleteDialog1.close();
    //                                 this.platform.handleErrorGracefully(error, 'Error while retrieving the existing table attributes. Please try again after sometime.');
    //                                 this.router.navigateByUrl('/controlplane');
    //                             });
    //                         } else {
    //                             this.isUseExistingTable = false;
    //                             entity.tableName = '';
    //                             //this.tableNameField.nativeElement.focus();
    //                             this.isCheckForExistingTableCompleted = false;
    //                             resolve('success');
    //                         }
    //                     } else {
    //                         this.isUseExistingTable = false;
    //                         entity.tableName = '';
    //                         //this.tableNameField.nativeElement.focus();
    //                         this.isCheckForExistingTableCompleted = false;
    //                         resolve('success');
    //                     }
    //                 });
    //             } else {
    //                 this.isUseExistingTable = false;
    //                 this.previousTableName = entity.tableName;
    //                 this.previousSelectedDatatypeFilter = this.selectedDatatypeFilter;
    //                 this.isCheckForExistingTableCompleted = false;
    //                 resolve('success');
    //                 deleteDialog.close();
    //             }
    //
    //         }, error => {
    //             deleteDialog.close();
    //             this.platform.handleErrorGracefully(error, 'Error while checking the existing tables in your account. Please try again after sometime.');
    //             this.router.navigateByUrl('/controlplane');
    //         });
    //     });
    // }
    validateBusinessLogicApi(entity, timeStamp, action) {

        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.specialCharAndPasteValidationForEntityNameAndVersion(entity.executor_name, entity.executor_version, timeStamp, action)).then(resp1 => {

                // let continueOperation = false;
                if (resp1) {

                    Promise.resolve(this.checkForExistingExecutor(entity.executor_name, entity.executor_version, entity.editFlag, timeStamp, action)).then(async continueOperation => {

                        if (continueOperation) {
                            this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_REQUIREMENTS, {
                                info: 'Validating Executor category',
                                type: 'initial',
                                icon: 'fa fa-file-code-o'
                            }, timeStamp, action);


                            if (entity.executor_category !== undefined && entity.executor_category !== '') {

                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_REQUIREMENTS, {
                                    info: 'Validating Executor category',
                                    type: 'success',
                                    icon: 'fa fa-file-code-o'
                                }, timeStamp, action);
                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DESIGN, {
                                    info: 'Retrieving Business Logic blocks',
                                    icon: 'fa fa-file-code-o',
                                    type: 'initial'
                                }, timeStamp, action);
                                await this.platform.delay(500);
                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DESIGN, {
                                    info: 'Retrieving Business Logic blocks',
                                    icon: 'fa fa-file-code-o',
                                    type: 'success'
                                }, timeStamp, action);
                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DEVELOPMENT, {
                                    info: 'Converting blocks to executors',
                                    icon: 'fa fa-file-code-o',
                                    type: 'initial'
                                }, timeStamp, action);
                                await this.platform.delay(500);
                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DEVELOPMENT, {
                                    info: 'Converting blocks to executors',
                                    icon: 'fa fa-file-code-o',
                                    type: 'success'
                                }, timeStamp, action);

                                resolve('success');
                            } else {
                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_REQUIREMENTS, {
                                    info: 'Validating Executor category',
                                    icon: 'fa fa-file-code-o',
                                    type: 'fatal',
                                    description: 'Please enter a valid executor category.'
                                }, timeStamp, action);
                                this.eventCallback.next({
                                    'apiName': entity.executor_name,
                                    'apiVersion': entity.executor_version,
                                    'result': 'failure',
                                    'message': 'Please enter a valid executor category.',
                                    'auditPayload': {
                                        statusCode: 400,
                                        message: 'Invalid payload'
                                    }
                                });

                                resolve('failed');
                            }
                        } else {
                            this.eventCallback.next({
                                'apiName': entity.executor_name,
                                'apiVersion': entity.executor_version,
                                'result': 'failure',
                                'message': 'An API with the provided name and version already exists.',
                                'auditPayload': {
                                    statusCode: 400,
                                    message: 'API already exists'
                                }
                            });
                            resolve('failed');
                        }
                    });


                } else {
                    this.eventCallback.next({
                        'apiName': entity.executor_name,
                        'apiVersion': entity.executor_version,
                        'result': 'failure',
                        'message': 'Special characters are not allowed in API name and version',
                        'auditPayload': {
                            statusCode: 400,
                            message: 'Special characters found in API name and version'
                        }
                    });
                }

            });
        });
    }

    createBusinessLogicApi(partner, account_id, entities, timeStamp, testMode = 'notests') {
        if (entities) {
            for (const entity of entities) {
                Promise.resolve(this.validateBusinessLogicApi(entity, timeStamp, entity.action)).then(response1 => {

                    if (response1 === 'success') {
                        this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DEVELOPMENT, {
                            info: 'Generating the API',
                            icon: 'fa fa-code',
                            type: 'initial'
                        }, timeStamp, entity.action);
                        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(partner, account_id, entity.executor_name, entity.executor_version).subscribe(exec => {
                            let executor = exec;
                            let eventNameForAudit = '';
                            if (entity.editFlag) {
                                eventNameForAudit = 'businesslogic_edit_redeploy_success';
                            } else {
                                eventNameForAudit = 'businesslogic_create_deploy_success';
                            }
                            this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DEVELOPMENT, {
                                info: 'Generating the API',
                                icon: 'fa fa-code',
                                type: 'success'
                            }, timeStamp, entity.action);

                            if (executor) {
                                if (entity.editFlag) {
                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                        info: 'Updating API Executor',
                                        type: 'initial',
                                        icon: 'fa fa-cloud-upload'
                                    }, timeStamp, entity.action);
                                    entity['creationTime'] = exec['creationTime'];
                                    entity['isDocumentationPublished'] = exec['isDocumentationPublished'];
                                    entity['nid'] = exec['nid'];
                                    entity['vid'] = exec['vid'];
                                    this.confPost.updateApiExecutorForPartnerAccount(partner, account_id, exec['id'], entity).subscribe(async data => {
                                        // this.orig_executor = fabResult;
                                        // if (data && data['body']) {
                                        //     this.orig_executor = data['body'];
                                        // }
                                        // this.xml_content = fabResult['source'];

                                        this.platform.updateAPIAuditLog(partner, account_id, entity['executor_name'], entity['executor_version'], 'BUSINESSLOGIC', entity, exec);


                                        // setInterval(() => this.manageProgress(), 1000);
                                        this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                            info: 'Updating Gateway Settings for the API',
                                            type: 'initial',
                                            icon: 'fa fa-shield'
                                        }, timeStamp, entity.action);
                                        this.kongService.updateRouteWithMethods(partner, account_id, entity.executor_name, entity.executor_version, [entity.executor_method_type], timeStamp, entity.action);
                                        this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                            info: 'Updating Gateway Settings for the API',
                                            type: 'success',
                                            icon: 'fa fa-shield'
                                        }, timeStamp, entity.action);
                                        this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                            info: 'Updating API Executor',
                                            type: 'success',
                                            icon: 'fa fa-cloud-upload'
                                        }, timeStamp, entity.action);
                                        this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                            info: 'Redeploying API',
                                            type: 'initial',
                                            icon: 'fa fa-cloud-upload'
                                        }, timeStamp, entity.action);
                                        this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                            info: 'Redeploying API',
                                            type: 'success',
                                            icon: 'fa fa-cloud-upload'
                                        }, timeStamp, entity.action);


                                        // this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                        //     info: 'Checking for testcases <br>Testcases found: 0',
                                        //     icon: 'fa fa-check-square-o',
                                        //     type: 'initial'
                                        // }, timeStamp, entity.action);
                                        // await this.platform.delay(1000);
                                        // this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                        //     info: 'Checking for testcases <br>Testcases found: 0',
                                        //     icon: 'fa fa-check-square-o',
                                        //     type: 'success'
                                        // }, timeStamp, entity.action);


                                        if (testMode === 'alltests') {
                                            this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                                info: 'Executing test-suites for API usages',
                                                icon: 'fa fa-check-square-o',
                                                type: 'initial',
                                                messageType: 'test-results'
                                            }, timeStamp, entity.action);
                                            this.confPost.getAPITestSuiteResult(this.partner, this.account_id, this.partnerKey, entity.executor_name, entity.executor_version).subscribe(async response => {
                                                let suiteResponse: any;
                                                suiteResponse = response;

                                                if (suiteResponse.testsPassRate === 100) {
                                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                                        info: 'Executing test-suites for API usages',
                                                        icon: 'fa fa-check-square-o',
                                                        type: 'success',
                                                        messageType: 'test-results',
                                                        description: 'Test Suite pass rate: 100%',
                                                        data: { testResultId: suiteResponse['resultsId'] }
                                                    }, timeStamp, entity.action);
                                                    await this.finishAPIDeployment(entity, timeStamp);
                                                } else {
                                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                                        info: 'Executing test-suites for API usages',
                                                        icon: 'fa fa-check-square-o',
                                                        type: 'warning',
                                                        description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                        messageType: 'test-results',
                                                        data: { testResultId: suiteResponse['resultsId'] }
                                                    }, timeStamp, entity.action);
                                                    await this.revertExecutorChanges(entity, timeStamp);
                                                }
                                            }, async error => {
                                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                                    info: 'Executing test-suites for API usages',
                                                    icon: 'fa fa-check-square-o',
                                                    type: 'error',
                                                    messageType: 'test-results',
                                                    description: 'Testsuite execution failed. Please try again.'
                                                }, timeStamp, entity.action);
                                                await this.revertExecutorChanges(entity, timeStamp);
                                            });

                                        } else if (testMode === 'force') {
                                            this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                                info: 'Executing test-suites for API usages',
                                                icon: 'fa fa-check-square-o',
                                                type: 'initial'
                                            }, timeStamp, entity.action);
                                            this.confPost.getAPITestSuiteResult(this.partner, this.account_id, this.partnerKey, entity.executor_name, entity.executor_version).subscribe(async response => {
                                                let suiteResponse: any;
                                                suiteResponse = response;

                                                if (suiteResponse.testsPassRate === 100) {
                                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                                        info: 'Executing test-suites for API usages',
                                                        icon: 'fa fa-check-square-o',
                                                        type: 'success',
                                                        messageType: 'test-results',
                                                        description: 'Test Suite pass rate: 100%',
                                                        data: {testResultId: suiteResponse['resultsId']}
                                                    }, timeStamp, entity.action);
                                                    await this.finishAPIDeployment(entity, timeStamp);
                                                } else {
                                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                                        info: 'Executing test-suites for API usages',
                                                        icon: 'fa fa-check-square-o',
                                                        type: 'warning-low',
                                                        description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                        messageType: 'test-results',
                                                        data: {testResultId: suiteResponse['resultsId']}
                                                    }, timeStamp, entity.action);
                                                    await this.finishAPIDeployment(entity, timeStamp);
                                                }

                                            }, error => {
                                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                                    info: 'Executing test-suites for API usages',
                                                    icon: 'fa fa-check-square-o',
                                                    type: 'error',
                                                    description: 'Testsuite execution failed. Please try again.'
                                                }, timeStamp, entity.action);
                                                this.finishAPIDeployment(entity, timeStamp);
                                            });
                                        } else {
                                            this.finishAPIDeployment(entity, timeStamp);
                                        }

                                        // await this.platform.delay(2000);
                                        // this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.DONE, {
                                        //     info: '',
                                        //     type: 'success',
                                        //     icon: 'fa fa-check'
                                        // }, timeStamp, entity.action);

                                    }, error => {
                                        this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                            info: 'Updating API Executor',
                                            type: 'fatal',
                                            description: 'Unknown error occured while updating the executor. Contact administrator.',
                                            icon: 'fa fa-cloud-upload'
                                        }, timeStamp, entity.action);

                                        this.eventCallback.next({
                                            'apiName': entity.executor_name,
                                            'apiVersion': entity.executor_version,
                                            'result': 'failure',
                                            'message': 'Unknown error occured while updating the executor. Contact administrator.',
                                            'auditPayload': {
                                                statusCode: error.status,
                                                message: error.statusText
                                            }
                                        });
                                        if (entity.editFlag) {
                                            eventNameForAudit = 'businesslogic_edit_redeploy_failed';
                                        } else {
                                            eventNameForAudit = 'businesslogic_create_deploy_failed';
                                        }
                                        let errorMessage = '';
                                        if (error.error['message']) {
                                            errorMessage = error.error.message;
                                        } else {
                                            let title = '';
                                            if (entity.editFlag) {
                                                title = 'Error while updating';
                                            } else {
                                                title = 'Error while creating';
                                            }
                                            const dialogRef = this.dialog.open(DialogComponent, {
                                                data: {title: title, message: error.error}
                                            });
                                            errorMessage = error.error;
                                        }
                                    });
                                }
                            } else {
                                // this.kongService.configureApiGatewayWithIpRestriction(partner, account_id, this.executor_name, this.selectedVersion, false, true);
                                // this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DEPLOYMENT, {
                                //     info: 'Deploying API',
                                //     type: 'initial',
                                //     icon: 'fa fa-cloud-upload'
                                // }, timeStamp, entity.action);
                                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, 'API DEVELOPMENT', {
                                    info: 'Setting up API',
                                    type: 'initial',
                                    icon: 'fa fa-edit'
                                }, timeStamp, 'deploy');
                                this.confPost.insertApiExecutorForPartnerAccount(partner, account_id, entity).subscribe(async data => {
                                    this.platform.createAPIAuditLog(partner, account_id, entity['executor_name'], entity['executor_version'], 'BUSINESSLOGIC', entity);
                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, 'API DEVELOPMENT', {
                                        info: 'Setting up API',
                                        type: 'success',
                                        icon: 'fa fa-edit'
                                    }, timeStamp, 'deploy');

                                    // setInterval(() => this.manageProgress(), 1000);
                                    this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'BUSINESSLOGIC').subscribe(data => {
                                        this.platform.businessLogicExecutors = data;

                                    });
                                    // this.kongService.configureApiGatewayWithIpRestriction(partner, account_id, this.executor_name, this.selectedVersion, false, true);
                                    await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(partner, account_id, entity.executor_name, entity.executor_version, false, true, [entity.executor_method_type], timeStamp, entity.action);
                                    // this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DEPLOYMENT, {
                                    //     info: 'Deploying API',
                                    //     type: 'success',
                                    //     icon: 'fa fa-cloud-upload'
                                    // }, timeStamp, entity.action);
                                    await this.platform.generateAccountRolePermissionGroupAndPermissions(partner, account_id, localStorage.getItem('signInEmail'), entity.executor_name, entity.executor_version, 'BUSINESSLOGIC', true, timeStamp, entity.action);

                                    this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                    this.leftPanelDataListener.notifyWorkflowBuilder.emit(entity.executor_name + '_' + entity.executor_version);
                                    // this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEPLOYMENT', {
                                    //   info:'Deploying API',
                                    //   type:'success',
                                    //   icon: 'fa fa-cloud-upload'}, timeStamp, action);
                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                                        info: 'Generating Documents',
                                        type: 'initial',
                                        icon: 'fa fa-book'
                                    }, timeStamp, entity.action);
                                    await this.platform.delay(1000);
                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                                        info: 'Generating Documents',
                                        type: 'success',
                                        icon: 'fa fa-book'
                                    }, timeStamp, entity.action);

                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                        info: 'Checking for testcases <br>Testcases found: 0',
                                        icon: 'fa fa-check-square-o',
                                        type: 'initial'
                                    }, timeStamp, entity.action);
                                    await this.platform.delay(1000);
                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                                        info: 'Checking for testcases <br>Testcases found: 0',
                                        icon: 'fa fa-check-square-o',
                                        type: 'success'
                                    }, timeStamp, entity.action);


                                    await this.platform.delay(2000);
                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.DONE, {
                                        info: '',
                                        type: 'success',
                                        icon: 'fa fa-check'
                                    }, timeStamp, entity.action);

                                    this.eventCallback.next({
                                        'apiName': entity.executor_name,
                                        'apiVersion': entity.executor_version,
                                        'result': 'success',
                                        'auditPayload': {
                                            statusCode: 201,
                                            message: 'API created'
                                        }
                                    });

                                    // this.platform.openSnackBar('API Deployed Successfully', 'Success', {
                                    //     duration: 10000,
                                    //     verticalPosition: 'top',
                                    //     horizontalPosition: 'center'
                                    // });
                                }, error => {
                                    if (entity.editFlag) {
                                        eventNameForAudit = 'businesslogic_edit_redeploy_failed';
                                    } else {
                                        eventNameForAudit = 'businesslogic_create_deploy_failed';
                                    }
                                    // this.platform.openSnackBar('We are working on the feature to deploy Business Logic APIs and Workflows onto Cloud... Meanwhile, please validate your designtime business use cases and let us know if you are interested in additional features.', 'Error', {
                                    //     duration: 10000,
                                    //     verticalPosition: 'top',
                                    //     horizontalPosition: 'center'
                                    // });
                                    let errorMessage = '';
                                    if (error.error['message']) {
                                        errorMessage = error.error.message;
                                    } else {
                                        const dialogRef = this.dialog.open(DialogComponent, {
                                            data: {title: 'Error while Creating', message: error.error}
                                        });
                                        errorMessage = error.error;
                                    }
                                    this.platform.publishEventMessage(entity.executor_name, entity.executor_version, 'API DEVELOPMENT', {
                                        info: 'Setting up API',
                                        type: 'fatal',
                                        description: errorMessage,
                                        icon: 'fa fa-edit'
                                    }, timeStamp, 'deploy');
                                });

                            }
                        }, error => {

                            this.eventCallback.next({
                                'apiName': entity.executor_name,
                                'apiVersion': entity.executor_version,
                                'result': 'failure',
                                'message': 'Unknown error occured while updating the executor. Contact administrator.',
                                'auditPayload': {
                                    statusCode: error.status,
                                    message: error.statusText
                                }
                            });

                            this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DEVELOPMENT, {
                                info: 'Generating the API',
                                icon: 'fa fa-code',
                                type: 'fatal',
                                description: 'There was an error while generating the API. Contact Administrator'
                            }, timeStamp, entity.action);
                        });
                    }
                });
            }////
        }
    }

    async finishAPIDeployment(entity, timeStamp, result = {completed: true, document: true}) {
        await this.platform.delay(500);
        if (result.completed) {
            if (result.document) {
                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Regenerating Documents',
                    type: 'initial',
                    icon: 'fa fa-book'
                }, timeStamp, entity.action);
                await this.platform.delay(2000);
                this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Regenerating Documents',
                    type: 'success',
                    icon: 'fa fa-book'
                }, timeStamp, entity.action);
            }
            this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.DONE, {
                info: '',
                type: 'success',
                icon: 'fa fa-check'
            }, timeStamp, entity.action);
        }

        this.eventCallback.next({
            'apiName': entity.executor_name,
            'apiVersion': entity.executor_version,
            'result': 'success',
            'auditPayload': {
                statusCode: 201,
                message: 'API created'
            }
        });
    }

    async revertExecutorChanges(entity, timeStamp) {
        this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
            info: 'Reverting changes to API',
            icon: 'fa fa-check-square-o',
            type: 'initial'
        }, timeStamp, entity.action);
        this.confPost.updateApiExecutorForPartnerAccount(entity.partner, entity.account_id, entity['oldExecutor']['id'], entity['oldExecutor']).subscribe(async data => {

            if (entity.executor_method_type !== entity['oldExecutor'].executor_method_type) {
                await this.kongService.updateRouteWithMethods(entity.partner, entity.account_id, entity.executor_name, entity.executor_version, [entity['oldExecutor'].executor_method_type], timeStamp, entity.action);
            }
            this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'success'
            }, timeStamp, entity.action);
            await this.finishAPIDeployment(entity, timeStamp, {completed: false, document: false});
        }, error => {
            this.platform.publishEventMessage(entity.executor_name, entity.executor_version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'fatal'
            }, timeStamp, entity.action);
            this.finishAPIDeployment(entity, timeStamp, {completed: false, document: false});
        });
    }

    // listenAPICreation(timestamp, apiName, apiVersion) {
    //     this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, 'deploy').subscribe(data => {
    //         if (data) {
    //             this.currentMessage = data;
    //         }
    //     });
    // }

    // checkForExistingTableAndAttributes(entity, params) {
    //     return new Promise((resolve, reject) => {
    //         const deleteDialog = this.dialog.open(LoaderWithProgressComponent, {
    //             maxWidth: '95vw',
    //             maxHeight: '60vh',
    //         });
    //         this.confPost.checkIfTableExists(this.partner, entity.tableName, entity.selectDatabase, params.selectedDatatypeFilter).subscribe(response => {
    //             if (response && response !== undefined && response !== null) {
    //                 deleteDialog.close();
    //                 const dialogRef = this.dialog.open(UseExistingTableConfirmationComponent, {
    //                     width: 'auto',
    //                     height: 'auto',
    //                     data: {
    //                         message: 'Checking for table existence...'
    //                     }
    //                 });
    //                 dialogRef.afterClosed().subscribe(result => {
    //                     if (result) {
    //                         if (result === 'yes') {
    //                             const deleteDialog1 = this.dialog.open(LoaderWithProgressComponent, {
    //                                 maxWidth: '95vw',
    //                                 maxHeight: '60vh',
    //                                 data: {
    //                                     message: 'Retrieving existing table attributes...'
    //                                 }
    //                             });
    //                             this.confPost.getTableAttributes(this.partner, entity.tableName, entity.selectDatabase, params.selectedDatatypeFilter).subscribe(response1 => {
    //                                 if (response1) {
    //                                     this.isUseExistingTable = true;
    //                                     this.isCheckForExistingTableCompleted = false;
    //                                     deleteDialog1.close();
    //                                     entity.apiByDefinition = response1;
    //                                     this.isAPIDefinitionImportedFromExistingTable = true;
    //                                     this.previousTableName = entity.tableName;
    //                                     this.previousSelectedDatatypeFilter = this.selectedDatatypeFilter;
    //                                     resolve('success');
    //                                 } else {
    //                                     this.platform.openSnackBar('Error while retrieving the existing table attributes. Please try again after sometime.', 'Error', {
    //                                         duration: 10000,
    //                                         verticalPosition: 'top',
    //                                         horizontalPosition: 'center'
    //                                     });
    //                                     this.isCheckForExistingTableCompleted = false;
    //                                     deleteDialog1.close();
    //                                     this.router.navigateByUrl('/controlplane');
    //                                 }
    //                             }, error => {
    //                                 this.isCheckForExistingTableCompleted = false;
    //                                 deleteDialog1.close();
    //                                 this.platform.handleErrorGracefully(error, 'Error while retrieving the existing table attributes. Please try again after sometime.');
    //                                 this.router.navigateByUrl('/controlplane');
    //                             });
    //                         } else {
    //                             this.isUseExistingTable = false;
    //                             entity.tableName = '';
    //                             //this.tableNameField.nativeElement.focus();
    //                             this.isCheckForExistingTableCompleted = false;
    //                             resolve('success');
    //                         }
    //                     } else {
    //                         this.isUseExistingTable = false;
    //                         entity.tableName = '';
    //                         //this.tableNameField.nativeElement.focus();
    //                         this.isCheckForExistingTableCompleted = false;
    //                         resolve('success');
    //                     }
    //                 });
    //             } else {
    //                 this.isUseExistingTable = false;
    //                 this.previousTableName = entity.tableName;
    //                 this.previousSelectedDatatypeFilter = this.selectedDatatypeFilter;
    //                 this.isCheckForExistingTableCompleted = false;
    //                 resolve('success');
    //                 deleteDialog.close();
    //             }
    //
    //         }, error => {
    //             deleteDialog.close();
    //             this.platform.handleErrorGracefully(error, 'Error while checking the existing tables in your account. Please try again after sometime.');
    //             this.router.navigateByUrl('/controlplane');
    //         });
    //     });
    // }

    CheckForExistingEntityOrExecutor(entity) {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(entity.entityName, entity.version)).then(response => {
                this.isAPIAlreadyPresent = false;
                this.isAPIAlreadyPresentCheckCompleted = false;
                this.previouslyCheckedName = entity.entityName;
                this.previouslyCheckedVersion = entity.version;
                resolve('success');
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = entity.entityName;
                        this.previouslyCheckedVersion = entity.version;
                        resolve('failed');
                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else if (error.status === 'failed') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = entity.entityName;
                        this.previouslyCheckedVersion = entity.version;
                        resolve('failed');
                        this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }
            });
        });
    }

    checkForExistingEntityAndExecutor(entity) {
        return new Promise(async (resolve, reject) => {
            if (entity.entityName !== null && entity.entityName !== undefined && entity.entityName !== '' && entity.version !== null && entity.version !== undefined && entity.version !== '') {
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
                        if (this.previouslyCheckedName !== entity.entityName || this.previouslyCheckedVersion !== entity.version) {
                            this.isAPIAlreadyPresentCheckCompleted = true;
                            await this.CheckForExistingEntityOrExecutor(entity);
                            resolve('success');
                        } else {
                            resolve('success');
                        }
                    } else {
                        this.isAPIAlreadyPresentCheckCompleted = true;
                        await this.CheckForExistingEntityOrExecutor(entity);
                        resolve('success');
                    }
                } else {
                    resolve('success');
                }
            } else {
                resolve('failure');
            }
        });
    }

    async createDaa(entities) {
        if (entities) {
            for (const entity of entities) {
                this.validateDataForAPICreation(entity);
            }
        }
    }

    validateDaas(entity, timeStamp, action) {

        const vers = ((typeof entity.version) === 'object' ? entity.version['name'] : entity.version);
        return new Promise(async (resolve, reject) => {

            if (entity.entityName !== undefined && entity.entityName !== null && entity.entityName.length !== 0 &&
                vers !== undefined && vers !== null && vers !== 0 &&
                entity.apiCategory !== undefined && entity.apiCategory !== null && entity.apiCategory.length !== 0 &&
                entity.methods !== undefined && entity.methods !== null && entity.methods.length !== 0 &&
                entity.selectDatabase !== undefined && entity.selectDatabase !== null && entity.selectDatabase.length !== 0 &&
                entity.apiByDefinition && entity.apiByDefinition.length && entity.apiByDefinition[0].attributeName !== null &&
                entity.tableName !== undefined && entity.tableName !== null && entity.tableName.length !== 0 &&
                (entity.tableName.charCodeAt(0) !== 35 && entity.tableName.charCodeAt(0) !== 36 && entity.tableName.charCodeAt(0) !== 64 && entity.tableName.charCodeAt(0) !== 95)) {
                Promise.resolve(this.platform.specialCharAndPasteValidationForEntityNameAndVersion(entity.entityName, vers, timeStamp, action)).then(resp => {

                    // let continueOperation = false;
                    if (resp) {
                        Promise.resolve(this.checkForExistingExecutor(entity.entityName, vers, false, timeStamp, action)).then(continueOperation => {
                            if (continueOperation) {
                                resolve('success');
                            } else {
                                this.eventCallback.next({
                                    'apiName': entity.entityName,
                                    'apiVersion': entity.version,
                                    'result': 'failure',
                                    'message': 'An API with the provided name and version already exists.',
                                    'auditPayload': {
                                        statusCode: 400,
                                        message: 'API already exists'
                                    }
                                });
                                resolve('failed');
                            }
                        });


                    } else {
                        this.eventCallback.next({
                            'apiName': entity.entityName,
                            'apiVersion': entity.version,
                            'result': 'failure',
                            'message': 'Special characters are not allowed in API name and version',
                            'auditPayload': {
                                statusCode: 400,
                                message: 'Special characters found in API name and version'
                            }
                        });
                    }

                });
            } else {

                this.eventCallback.next({
                    'apiName': entity.entityName,
                    'apiVersion': entity.version,
                    'result': 'failure',
                    'message': 'Please enter all the required fields',
                    'auditPayload': {
                        statusCode: 400,
                        message: 'Invalid payload'
                    }
                });

                if (entity.entityName === undefined || entity.entityName === '' || entity.entityName === null || entity.entityName.length === 0) {
                    // this.platform.openSnackBar('Please enter a valid name for Data Access Service', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    this.platform.publishEventMessage(entity.entityName, vers, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Validating Data Access Service name',
                        type: 'initial',
                        icon: 'fa fa-check'
                    }, timeStamp, action);
                    await this.platform.delay(500);
                    this.platform.publishEventMessage(entity.entityName, vers, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Validating Data Access Service name',
                        type: 'fatal',
                        description: 'Please enter a valid executor name.',
                        icon: 'fa fa-check'
                    }, timeStamp, action);

                    // this.platform.openSnackBar('Please enter a valid name for Data Access Service.', 'Error', null);

                }
                if (vers === undefined || vers === '' || vers === null || vers === 0) {
                    this.platform.publishEventMessage(entity.entityName, vers, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Validating Data Access Service version',
                        type: 'initial',
                        icon: 'fa fa-check'
                    }, timeStamp, action);
                    await this.platform.delay(500);
                    this.platform.publishEventMessage(entity.entityName, vers, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Validating Data Access Service version',
                        type: 'fatal',
                        description: 'Please enter a valid executor version.',
                        icon: 'fa fa-check'
                    }, timeStamp, action);
                    // this.platform.openSnackBar('Please enter a valid version for Data Access Service', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                }

                if (entity.apiCategory === undefined || entity.apiCategory === '' || entity.apiCategory === null || entity.apiCategory.length === 0) {
                    // this.platform.openSnackBar('Please enter a valid category for Data Access Service', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating Category',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o',
                    }, timeStamp, action);
                    await this.platform.delay(500);
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating Category',
                        type: 'fatal',
                        icon: 'fa fa-newspaper-o',
                        description: 'Please enter a valid category for Data Access Service'
                    }, timeStamp, action);
                }

                if (entity.selectDatabase === undefined || entity.selectDatabase === null || entity.selectDatabase.length === 0) {
                    // this.platform.openSnackBar('Please select a database to create this service', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating database',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o',
                    }, timeStamp, action);
                    await this.platform.delay(500);
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating database',
                        type: 'fatal',
                        icon: 'fa fa-newspaper-o',
                        description: 'Please select a database to create this service'
                    }, timeStamp, action);

                }
                if (entity.tableName === undefined || entity.tableName === null || entity.tableName.length === 0 ||
                    !(entity.tableName.charCodeAt(0) !== 35 && entity.tableName.charCodeAt(0) !== 36 && entity.tableName.charCodeAt(0) !== 64 && entity.tableName.charCodeAt(0) !== 95)) {
                    // this.platform.openSnackBar('Please select a database to create this service', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating table/collection',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o',
                    }, timeStamp, 'deploy');
                    await this.platform.delay(500);
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating table/collection',
                        type: 'fatal',
                        icon: 'fa fa-newspaper-o',
                        description: 'Please enter a valid table/collection name'
                    }, timeStamp, 'deploy');

                }


                if (entity.methods === undefined || entity.methods === [] || entity.methods === null || entity.methods.length === 0) {
                    // this.platform.openSnackBar('You need to select at least one Method Type to create this service', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating methods',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o',
                    }, timeStamp, 'deploy');
                    await this.platform.delay(500);
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating methods',
                        type: 'fatal',
                        icon: 'fa fa-newspaper-o',
                        description: 'You need to select at least one Method Type to create this service'
                    }, timeStamp, 'deploy');
                }

                if (entity.apiByDefinition && entity.apiByDefinition.length && entity.apiByDefinition[0].attributeName === null) {
                    // this.platform.openSnackBar('You need to select at least one Attribute to create this service', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating attributes',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o',
                    }, timeStamp, 'deploy');
                    await this.platform.delay(500);
                    this.platform.publishEventMessage(entity.entityName, vers, 'API REQUIREMENTS', {
                        info: 'Validating attributes',
                        type: 'fatal',
                        description: 'You need to select at least one Attribute to create this service',
                        icon: 'fa fa-newspaper-o',
                    }, timeStamp, 'deploy');
                }
            }
        });
    }

    async validateDataForAPICreation(entity) {
        const timeStamp = entity.timeStamp;
        const action = entity.action; //TBD

        Promise.resolve(this.validateDaas(entity, timeStamp, action)).then(async resp1 => {

                if (resp1 === 'success') {

                    const temparray = [];
                    for (let i = 0; i < entity.apiByDefinition.length; i++) {
                        if (entity.apiByDefinition[i]['attributeName'] !== null && entity.apiByDefinition[i]['type'] !== null) {
                            temparray.push(entity.apiByDefinition[i]);
                        }
                    }
                    entity.apiByDefinition = temparray;

                // this.platform.publishEventMessage(entity.entityName, entity.version, 'API DESIGN', {
                //     info: 'Validating schema',
                //     type: 'initial',
                //     icon: 'fa fa-newspaper-o'
                // }, timeStamp, 'deploy');
                // await this.platform.delay(500);
                // if (entity.apiByDefinition && entity.apiByDefinition.length === 0) {
                //     // alert('Please add schema definition');
                //     // this.platform.openSnackBar('Please define schema under Schema Definition', 'Error', {
                //     //     duration: 10000,
                //     //     verticalPosition: 'top',
                //     //     horizontalPosition: 'center'
                //     // });
                //
                //     this.platform.publishEventMessage(entity.entityName, entity.version, 'API DESIGN', {
                //         info: 'Validating schema',
                //         type: 'fatal',
                //         description: 'Please define schema under Schema Definition',
                //         icon: 'fa fa-newspaper-o'
                //     }, timeStamp, 'deploy');
                // } else {
                //     this.platform.publishEventMessage(entity.entityName, entity.version, 'API DESIGN', {
                //         info: 'Validating schema',
                //         type: 'success',
                //         icon: 'fa fa-newspaper-o'
                //     }, timeStamp, 'deploy');
                // }

                const vers = ((typeof entity.version) === 'object' ? entity.version['name'] : entity.version);

                const that = this;
                let entityLength = 0;
                let versionLength = 0;

                for (let i = 0; i < entity.entityName.length; i++) {
                    if (entity.entityName.charCodeAt(i) === 8 || entity.entityName.charCodeAt(i) === 32 || (entity.entityName.charCodeAt(i) > 64 && entity.entityName.charCodeAt(i) < 91) || (entity.entityName.charCodeAt(i) > 96 && entity.entityName.charCodeAt(i) < 123) || (entity.entityName.charCodeAt(i) >= 48 && entity.entityName.charCodeAt(i) <= 57)) {
                        entityLength++;
                    }
                }

                for (let i = 0; i < entity.version.length; i++) {
                    if (entity.version.charCodeAt(i) === 8 || entity.version.charCodeAt(i) === 32 || (entity.version.charCodeAt(i) > 64 && entity.version.charCodeAt(i) < 91) || (entity.version.charCodeAt(i) > 96 && entity.version.charCodeAt(i) < 123) || (entity.version.charCodeAt(i) >= 48 && entity.version.charCodeAt(i) <= 57)) {
                        versionLength++;
                    }
                }

                if (entity.tableName.charCodeAt(0) !== 35 && entity.tableName.charCodeAt(0) !== 36 && entity.tableName.charCodeAt(0) !== 64 && entity.tableName.charCodeAt(0) !== 95) {
                    this.isValidTableName = true;
                }
                const methods = [];
                if (entity.ispublished) {
                    this.platform.publishEventMessage(entity.entityName, entity.version, 'API DESIGN', {
                        info: 'Preparing for API methods',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, 'deploy');
                    await this.platform.delay(500);
                    this.platform.publishEventMessage(entity.entityName, entity.version, 'API DESIGN', {
                        info: 'Preparing for API methods',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, 'deploy');
                } else {
                    entity.scopeSelected = 'private';
                }
                if (entityLength === entity.entityName.length) {
                    if (versionLength === entity.version.length) {
                        this.preparingSchema(entity, timeStamp);

                    }
                }
                }
            });
    }



    //API Design
    async preparingSchema(entity, timeStamp) {
        // Validate schema & confirm
        this.platform.publishEventMessage(entity.entityName, entity.version, 'API DESIGN', {
            info: 'Reading schema from API design',
            type: 'inital',
            icon: 'fa fa-file-code-o'
        }, timeStamp, 'deploy');
        const crudAPI = {
            'entityname': entity.entityName,
            'category': ((typeof entity.apiCategory) === 'object' ? entity.apiCategory['name'] : entity.apiCategory),
            'tableName': entity.tableName !== null ? entity.tableName : this.account_id + '_' + entity.entityName + '_' + ((typeof entity.version) === 'object' ? entity.version['name'] : entity.version),
            'displayname': entity.displayName,
            'description': entity.description,
            'published': entity.ispublished,
            'scopeOfAccess': entity.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': entity.selectDatabase,
            'version': ((typeof entity.version) === 'object' ? entity.version['name'] : entity.version),
            'methods': entity.methods,
            'attributes': entity.apiByDefinition,
            'gatewayManagers': [entity.selectedAPIGatewayName],
            'tableCreation': entity.tableCreation
        };

        await this.platform.delay(2000);
        this.platform.publishEventMessage(entity.entityName, entity.version, 'API DESIGN', {
            info: 'Reading schema from API design',
            type: 'success',
            icon: 'fa fa-file-code-o'
        }, timeStamp, 'deploy');

        this.insertApi(entity, crudAPI, timeStamp);
    }

    //API Development
    insertApi(entity, crudAPI, timeStamp) {
        // Insert the entity
        this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEVELOPMENT', {
            info: 'Setting up API',
            type: 'initial',
            icon: 'fa fa-edit'
        }, timeStamp, 'deploy');

        this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(async data => {
            if (data && data['message'] === 'API already exists.') {
                // this.save = false;
                // this.loading = false;
                // this.platform.openSnackBar(data['message'], 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
                this.eventCallback.next({
                    'apiName': entity.entityName,
                    'apiVersion': entity.version,
                    'result': 'failure',
                    'message': data['message'],
                    'auditPayload': {
                        statusCode: 400,
                        message: data['message']
                    }
                });
                this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEVELOPMENT', {
                    info: 'Setting up API',
                    type: 'fatal',
                    description: data['message'],
                    icon: 'fa fa-edit'
                }, timeStamp, 'deploy');

                // Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, 'API_DEPLOY', 'DATA_ACCESS_API', 'API_DEPLOY',  'DEPLOY', 'FAIL', crudAPI, data.status, data, '', data['message'])).then(response => {
                //     this.auditListenerService.auditListener.emit({
                //         type: 'auditLog',
                //         category: 'isAuditForDataAccess',
                //         id: localStorage.getItem('auditId'),
                //         payload: response
                //     });
                // });
                //this.platform.publishEventMessage(this.entityName, this.version,'CREATION', 'API already exists');
            } else {

                //     Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, 'API_DEPLOY', 'DATA_ACCESS_API', 'API_DEPLOY',  'DEPLOY', 'SUCCESS', crudAPI, data.status, data, data['message'])).then(response => {
                //     const payloadToSend = {
                //         actions: response
                //     };
                //     this.auditListenerService.auditListener.emit({
                //         type: 'auditLog',
                //         category: 'isAuditForDataAccess',
                //         id: localStorage.getItem('auditId'),
                //         payload: response
                //     });
                // });
                await this.configureServiceAndRoutes(entity, crudAPI, data, timeStamp);
            }
        }, error => {
            //this.loading = false;

            let errorMessage = '';
            if (error.error) {
                if (error.error['message']) {
                    errorMessage = error.error.message;
                } else {
                    errorMessage = error.error;
                }
            } else {
                errorMessage = 'Error while creating the API. Please try again sometime.';
            }
            this.eventCallback.next({
                'apiName': entity.entityName,
                'apiVersion': entity.version,
                'result': 'failure',
                'message': errorMessage,
                'auditPayload': {
                    statusCode: 400,
                    message: errorMessage
                }
            });
            this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEVELOPMENT', {
                info: 'Setting up API',
                type: 'fatal',
                description: errorMessage,
                icon: 'fa fa-edit'
            }, timeStamp, 'deploy');
            this.platform.handleErrorGracefully(error, 'Error while creating the API. Please try again sometime.');
        });
    }

    //API Deployment
    async configureServiceAndRoutes(entity, crudAPI, data, timeStamp) {
        // this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
        //     info: 'Deploying API',
        //     type: 'initial',
        //     icon: 'fa fa-cloud-upload'
        // }, timeStamp, 'deploy');

        await this.platform.createAPIAuditLog(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI['entityname'], crudAPI['version'], 'DAAS', crudAPI);
        this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEVELOPMENT', {
            info: 'Setting up API',
            type: 'success'
        }, timeStamp, 'deploy');
        if (entity.ispublished) {
            this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
                // localStorage.setItem('dataAccessAPI' , JSON.stringify(data));
                this.platform.apiExecutors = data;
                // localStorage.setItem('isDataAccessAPISet', 'true');
                this.platform.isDataAccessAPISet = 'true';
                // localStorage.setItem('updatedDataAccessAPI', JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']}));
                this.platform.updatedDataAccessAPI = JSON.stringify({
                    'entityName': crudAPI['entityname'],
                    'version': crudAPI['version']
                });
            });
        }
        // await this.platform.delay(2000);

        await this.configureGatewaySettings(entity, timeStamp);
        // this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
        //     info: 'Deploying API',
        //     type: 'success',
        //     icon: 'fa fa-cloud-upload'
        // }, timeStamp, 'deploy');

        await this.generatePermissions(entity, timeStamp);

        await this.completeApiCreation(entity, timeStamp);

        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
        this.leftPanelDataListener.notifyWorkflowBuilder.emit(crudAPI.methods[0].toLowerCase() + crudAPI.entityname + '_' + crudAPI.version);
    }

    //combine these 2, its OK
    //API Gateway Settings
    async configureGatewaySettings(entity, timeStamp) {
        // Rate Limiting, IP Restriction, CORS, etc
        if (entity.ispublished) {
            // this.configureApiGateway();
            //this.platform.publishEventMessage(this.entityName, this.version,'API GATEWAY MANAGEMENT', {info:'Configuring Gateway Settings for the API',type:'initial', icon: 'fa fa-shield'}, timeStamp, 'deploy');
            await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), entity.entityName, ((typeof entity.version) === 'object' ? entity.version['name'] : entity.version), false, false, entity.methods, timeStamp, entity.action);
            //this.platform.publishEventMessage(this.entityName, this.version,'CONFIGURING API GATEWAY AND ACCESS POLICIES', {info:'Configuring Gateway Settings for the API',type:'success', icon: 'fa fa-shield'}, timeStamp, 'deploy');

            // this.confPost.getApiExecutorsByPartnerAccountEntityVersion(this.partner, this.account_id, this.entityName, this.version).subscribe(data=>{
            //     if (data) {
            //         this.operations = data;
            //         this.selectedCredentialTabIndex = 2;
            //     }
            // });

        }

    }

    //API Security
    async generatePermissions(entity, timeStamp) {
        await Promise.resolve(this.platform.generateAccountRolePermissionGroupAndPermissions(this.partner, this.account_id, localStorage.getItem('signInEmail'), entity.entityName, entity.version, 'DAAS', true, timeStamp, entity.action)).then(async resp => {
            //  this.platform.publishEventMessage(this.entityName, this.version,'CONFIGURING PLATFORM PERMISSIONS', {info:'Configuring platform permissions for data access service',type:'success', icon: 'fa fa-cogs'}, timeStamp, 'deploy');
            await this.platform.delay(500);
        }, async error => {
            //  this.platform.publishEventMessage(this.entityName, this.version,'GENERATING_PERMISSION', {info:'Permissions creation failed' ,type:'error', icon: 'fa fa-shield'}, timeStamp, 'deploy');
            await this.platform.delay(500);
        });
    }

    //API Testing
    testApi() {

    }

    //Complete API
    async completeApiCreation(entity, timeStamp) {
        //Done
        //Navigations
        this.platform.publishEventMessage(entity.entityName, entity.version, 'API DOCUMENTATION', {
            info: 'Generating Documents',
            type: 'initial',
            icon: 'fa fa-book'
        }, timeStamp, 'deploy');
        await this.platform.delay(1000);
        this.platform.publishEventMessage(entity.entityName, entity.version, 'API DOCUMENTATION', {
            info: 'Generating Documents',
            type: 'success',
            icon: 'fa fa-book'
        }, timeStamp, 'deploy');


        this.platform.publishEventMessage(entity.entityName, entity.version, 'API TESTING', {
            info: 'Checking for testcases <br>Testcases found: 0',
            icon: 'fa fa-check-square-o',
            type: 'initial'
        }, timeStamp, 'deploy');
        await this.platform.delay(1000);
        this.platform.publishEventMessage(entity.entityName, entity.version, 'API TESTING', {
            info: 'Checking for testcases <br>Testcases found: 0',
            icon: 'fa fa-check-square-o',
            type: 'success'
        }, timeStamp, 'deploy');

        await this.platform.delay(1500);
        this.eventCallback.next({
            'apiName': entity.entityName,
            'apiVersion': entity.version,
            'result': 'success',
            'auditPayload': {
                statusCode: 201,
                message: 'API created'
            }
        });
        this.platform.publishEventMessage(entity.entityName, entity.version, 'DONE', {
            info: '',
            type: 'success',
            icon: 'fa fa-check'
        }, timeStamp, 'deploy');
        // if (!this.connection) {
        //     this.platform.openSnackBar('API Deployed Successfully', 'Success', {
        //         duration: 10000,
        //         verticalPosition: 'top',
        //         horizontalPosition: 'center'
        //     });
        // }
    }


}
